<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive' }" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'Other' }" tag="li" class="breadcrumb-item">
						<a href="#">其他資訊</a>
					</router-link>
					<li class="breadcrumb-item active">
						角色出場順序
					</li>
				</ol>
			</nav>
			<div class="item-box">
				<div class="row mb-3">
					<div class="col">
						需要更多資訊請至
						<a href="https://forum.gamer.com.tw/C.php?bsn=30861&snA=5633" target="_blank">
							巴哈姆特 【情報】公主連結☆台日活動日程表
						</a>
					</div>
				</div>
				<div class="row">
					<div class="col-6">
						<h3 class="item-title">臺版角色順序</h3>
						<div class="card-deck mb-3" v-for="(item, index) in twList">
							<div class="card text-center p-3">
								<span class="m-1 d-block d-lg-inline">{{ item.start_index_tw }}.</span>
								<span class="m-1 d-block d-lg-inline" v-html="getGachaType(item.gachaType)"></span>
								<img style="width: 80px" class="m-auto"
									:src="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 30) + '.png'" alt="">
								<span class="m-1 d-block d-lg-inline">{{ item.unit_name }}</span>
								<span class="m-1 d-block d-lg-inline">{{ item.start_time_tw }}</span>
							</div>
						</div>
					</div>
					<div class="col-6">
						<h3 class="item-title">日版角色順序</h3>
						<div class="card-deck mb-3" v-for="(item, index) in jpList">
							<div class="card text-center p-3">
								<span class="m-1 d-block d-lg-inline">{{ item.start_index_jp }}.</span>
								<span class="m-1 d-block d-lg-inline" v-html="getGachaType(item.gachaType)"></span>
								<img style="width: 80px" class="m-auto"
									:src="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 30) + '.png'" alt="">
								<span class="m-1 d-block d-lg-inline">{{ item.unit_name }}</span>
								<span class="m-1 d-block d-lg-inline">{{ item.start_time_jp }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import axios from 'axios';
import GachaPool from "../../assets/edata/gacha_pool.json";
export default {
	name: 'UnitStartList',
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: '角色出場順序',
		// all titles will be injected into this template
		titleTemplate: '%s | 蘭德索爾圖書館 公主連結 Wiki',
		meta: [
			{ name: 'description', content: '查詢臺日角色出場的順序' }
		]
	},
	data() {
		return {
			unitList: [],
			twNow: 0,
			gachaPool: GachaPool,
		}
	},
	methods: {
		getUnitList: function (value) {
			var self = this;
			axios.get('/static/data/unitStartList.json')
				.then(function (response) {
					self.unitList = response.data.unitList;
					self.twNow = response.data.twNow;
				});
		},
		getPool: function (unit_id) {
			var self = this;
			return _.findKey(self.gachaPool, function (item) { return item.indexOf(unit_id) !== -1; });
		},
		getGachaType: function (gachaType) {
			var self = this;
			var name = "";
			var color = "secondary";
			switch (gachaType) {
				case "always":
					name = "常駐池";
					color = "primary"
					break;
				case "season":
					name = "季節限定";
					color = "danger"
					break;
				case "limited":
					name = "期間限定";
					color = "success"
					break;
				case "fes":
					name = "公主祭典";
					color = "warning"
					break;
				case "star1":
					name = "一星";
					break;
				case "star2":
					name = "二星";
					break;
				case "eventStar1":
					name = "活動一星";
					break;
				default:
					name = "尚未更新";
					return;
			}
			return `<span class='badge badge-${color}'>${name}</span>`;
		},
		getGachaType1: function (item) {
			var self = this;
			var name = "";
			switch (item) {
				case "always":
					name = "常駐池";
					break;
				case "season":
					name = "季節限定";
					break;
				case "limited":
					name = "期間限定";
					break;
				case "fes":
					name = "公主祭典";
					break;
				case "star1":
					name = "一星";
					break;
				case "star2":
					name = "二星";
					break;
				case "eventStar1":
					name = "活動一星";
					break;
				default:
					name = "尚未更新";
					break;
					return;
			}
			return name;
		}

	},
	created: function () {
		var self = this;
		this.getUnitList();
	},
	computed: {
		twList: function () {
			var self = this;
			var unitList = self.unitList
			_.forEach(unitList, function (obj) {
				var unit = _.find(self.$store.getters.getUnitData, ["unit_id", obj.unit_id]);
				obj["gachaType"] = self.getPool(obj.unit_id);
				obj["unit_name"] = unit.unit_name;
			});
			return _.orderBy(unitList, ['start_index_tw', 'unit_id'], ['desc', 'desc']);
		},
		jpList: function () {
			var self = this;
			var unitList = self.unitList
			_.forEach(unitList, function (obj) {
				var unit = _.find(self.$store.getters.getUnitData, ["unit_id", obj.unit_id]);
				obj["gachaType"] = self.getPool(obj.unit_id);
				obj["unit_name"] = unit.unit_name;
			});
			return _.orderBy(unitList, ['start_index_jp', 'unit_id'], ['desc', 'desc']);
		}
	},
	mounted: function () { }
}
</script>
<style scoped></style>